import React from 'react';
import { Gift, User, Globe, UserX } from 'lucide-react';
import { QuizSummary } from '../../types';

interface QuizIconProps {
    quizSummary: QuizSummary;
    userId: string;
}

const QuizIcon: React.FC<QuizIconProps> = ({ quizSummary, userId }) => {
    const isGifted = quizSummary.isGiftedItem === true;
    const isOwnQuiz = quizSummary.authorId === userId;
    const isPublic = quizSummary.isPublic === true;

    // isOwnQuiz と isPublic が両方 false の場合は UserX を表示
    const isUnknown = !isGifted && !isOwnQuiz && !isPublic;

    return (
        <div className="flex items-center space-x-1">
            {isGifted && (
                <Gift color="#FF4500" size={22} aria-label="ギフトクイズ" />
            )}
            {isOwnQuiz && (
                <User color="#FFD700" size={isGifted ? 18 : 22} aria-label="自分のクイズ" />
            )}
            {isPublic && (
                <Globe color="#2ECC71" size={isGifted || isOwnQuiz ? 18 : 22} aria-label="公開クイズ" />
            )}
            {isUnknown && (
                <UserX color="#607D8B" size={22} aria-label="状態不明のクイズ" />
            )}
        </div>
    );
};

export default QuizIcon;